<ng-container *ngIf="checkInGame as status">
  <div class="container user-general-info">
    <div class="profile-avatar-container">
      <div class="random-avatar">
        <button class="btn btn-sm moder" (click)="setRandomAvatar()">random</button>
      </div>
      <div class="profile-avatar">
        <img class="profile-img" src="{{user.avatar}}" alt="{{user.name}}"/>
        <div class="profile-lvl">{{user.lvl}}</div>
      </div>
    </div>
    <div class="profile-container">
      <div class="name">
        <ng-container *ngIf="!isUserNameEditing then name; else changeName"></ng-container>
        <ng-template #name>
          <span>{{user.name}}</span>
          <mat-icon class="icon" (click)="isUserNameEditing = !isUserNameEditing">edit</mat-icon>
        </ng-template>

        <ng-template #changeName>
          <input [(ngModel)]="user.name"
                 (keydown.enter)="changeUserName(value.value); isUserNameEditing = !isUserNameEditing"
                 #value>
          <mat-icon class="icon"
                    (click)="changeUserName(value.value); isUserNameEditing = !isUserNameEditing"
          >check
          </mat-icon>
        </ng-template>
      </div>
      <div class="profile-details">
        <div class="common">
          <div>
            <span class="description">id: </span> <span>{{user.fastId}}</span>
            <mat-icon class="copy-icon" [cdkCopyToClipboard]="user.fastId.toString()">file_copy</mat-icon>
          </div>
          <div>
            <span class="description">steam: </span> <span>{{user.steamId}}</span>
            <mat-icon class="copy-icon" [cdkCopyToClipboard]="user.steamId.toString()">file_copy</mat-icon>
          </div>
          <div><span class="description">reg.: </span> <span>{{user.registered | date:'dd.LL.YY'}}</span></div>
          <div>
            <span class="description">logged at: </span> <span>{{user.dateLogged | date: 'dd.MM.yy HH:mm'}}</span>
          </div>
          <div>
            <span class="description">last domain: </span> <span>{{user.lastDomain || '-'}}</span>
          </div>
          <div class="common-item">
            <span class="description">referrer: </span>
            <ng-container *ngIf="user.referral then ref else noref"></ng-container>
            <ng-template #ref>
              <div class="item">
                <a
                  [routerLink]="['/user', user.referral.referrer.user.id]"> {{user.referral.referrer.user.name}}</a>
                <mat-icon class="copy-icon" (click)="openReferralInfo(user.referral)">information</mat-icon>
              </div>
            </ng-template>
            <ng-template #noref>-</ng-template>
          </div>
        </div>
        <div class="actions">
          <div *ngIf="isGoFast" class="in-game-status">
            <span class="description">Status: </span>
            <ng-container *ngIf="status.inGame then online; else offline"></ng-container>
            <ng-template #online><span class="status"
                                       [ngStyle]="{'background-color':status.inGame ? 'green': ''}"></span>
              <span> {{status.list.join(', ')}}</span>
            </ng-template>
            <ng-template #offline><span class="status"></span>Not in game</ng-template>
            <mat-icon class="status-update" (click)="updateInGameStatus()">replay</mat-icon>
          </div>
          <div *ngIf="isGoFast" class="account-type">
            <span class="description">Type:</span>
            <span> {{user.profileType}}</span>
            <mat-icon class="icon"
                      matTooltip="Пересчитать"
                      matTooltipPosition="above"
                      (click)="recalculateAccountType()"
            >replay
            </mat-icon>
            <mat-icon class="icon"
                      matTooltip="Пересчитать с даунгрейдом"
                      matTooltipPosition="above"
                      (click)="recalculateAccountTypeWithDowngrade()"
            >trending_down
            </mat-icon>
          </div>
          <div *ngIf="isGoFast" class="vip-type">
            <span class="description">VIP type:</span>
            <span> {{user.vipTier?.name || user.vipRank || '-'}}</span>
          </div>
          <div *ngIf="isGoFast"><span class="description">Demo: </span>{{user.balance.demoCoins / 100 }}</div>
          <div>
            <ng-container *ngIf="user.isExcludeStats then excluded; else canExclude"></ng-container>
            <ng-template #excluded>
              <span class="description">Excluded from stats</span>
            </ng-template>
            <ng-template #canExclude>
              <button class="button btn btn-sm moder" (click)="excludeFromStats(user.fastId)">Exclude from stats
              </button>
            </ng-template>
          </div>
          <div>
            <button class="btn btn-sm moder" (click)="showModeratorsLog(user.fastId)">Moderators log</button>
          </div>
        </div>
        <div class="total-income">
          <div class="total-income-table">
            <div class="row">
              <div class="column-name">Current balance</div>
              <div class="column-name">Refill</div>
              <div class="column-name">Withdraw</div>
              <div class="column-name">Profit</div>
            </div>
            <div class="row row-1">
              <div class="value"
                   matTooltip="{{balanceTopPanel?.unitedBalance | fastCoinsToDollar}}"
                   matTooltipPosition="above"
                   [matTooltipDisabled]="!isGoFast"
              >{{balanceTopPanel?.unitedBalance / 100 || 0 | number | customCurrency}}</div>
              <div class="value"
                   matTooltip="{{balanceTopPanel?.pay | fastCoinsToDollar}}"
                   matTooltipPosition="above"
                   [matTooltipDisabled]="!isGoFast"
              >{{balanceTopPanel?.pay / 100 || 0 | number}}</div>
              <div class="value"
                   matTooltip="{{balanceTopPanel?.out | fastCoinsToDollar}}"
                   matTooltipPosition="above"
                   [matTooltipDisabled]="!isGoFast"
              >{{balanceTopPanel?.out / 100 || 0 | customCurrency}}</div>
              <div class="value" [ngClass]="balanceTopPanel?.profit>0?'green':'red'"
                   matTooltip="{{balanceTopPanel?.profit | fastCoinsToDollar}}"
                   matTooltipPosition="above"
                   [matTooltipDisabled]="!isGoFast"
              >{{balanceTopPanel?.profit / 100 || 0 | number | customCurrency}}</div>
            </div>
            <div class="row row-3">
              <div class="value real">
                <ng-container *ngIf="(additionalWallets$ | async) as additionalWallets">
                  <span class="material-icons wallets-trigger"
                        [class.has-wallets]="additionalWallets.length"
                        [matTooltip]="additionalWallets.length ? 'Other wallets (' + additionalWallets.length + ')' : 'No other wallets'"
                        matTooltipPosition="left"
                        (click)="additionalWallets.length && (isAdditionalWalletsExpanded = !isAdditionalWalletsExpanded)">
                    &#xef63;
                  </span>
                  <div *ngIf="isAdditionalWalletsExpanded && additionalWallets.length" class="additional-wallets">
                    <div class="additional-wallet" *ngFor="let wallet of additionalWallets">
                      <span class="additional-wallet-title">{{ wallet.title }}</span>
                      <span class="additional-wallet-balance"
                            matTooltip="{{wallet.balance | fastCoinsToDollar}}"
                            matTooltipPosition="above"
                            [matTooltipDisabled]="!isGoFast">
                        {{ wallet.balance / 100 || 0 | number | customCurrency }}
                      </span>
                    </div>
                  </div>
                </ng-container>
                    <span
                      matTooltip="{{balanceTopPanel?.balance | fastCoinsToDollar}}"
                      matTooltipPosition="above"
                      [matTooltipDisabled]="!isGoFast"
                    >{{balanceTopPanel?.balance / 100 || 0 | number | customCurrency}}</span>
                <mat-icon class="mat-icon mat-icon-btn edit" (click)="openChangeBalance()">edit</mat-icon>
              </div>
              <div class="value"
                   matTooltip="{{balanceTopPanel?.payMoney | fastCoinsToDollar}}"
                   matTooltipPosition="above"
                   [matTooltipDisabled]="!isGoFast"
              >{{balanceTopPanel?.payMoney / 100 || 0 | number | customCurrency}}</div>
              <div class="value"
                   matTooltip="{{balanceTopPanel?.outMoney | fastCoinsToDollar}}"
                   matTooltipPosition="above"
                   [matTooltipDisabled]="!isGoFast"
              >{{balanceTopPanel?.outMoney / 100 || 0 | number | customCurrency}}</div>
            </div>
            <div *ngIf="isGoFast" class="row row-4">
              <div class="value">
                    <span
                      matTooltip="{{balanceTopPanel?.inventoryBalance | fastCoinsToDollar}}"
                      matTooltipPosition="above"
                      [matTooltipDisabled]="!isGoFast"
                    >{{balanceTopPanel?.inventoryBalance / 100 || 0 | number | customCurrency}}</span>
              </div>
              <div class="value"
                   matTooltip="{{balanceTopPanel?.paySkins | fastCoinsToDollar}}"
                   matTooltipPosition="above"
                   [matTooltipDisabled]="!isGoFast"
              >{{balanceTopPanel?.paySkins / 100 || 0 | number | customCurrency}}</div>
              <div class="value"
                   matTooltip="{{balanceTopPanel?.outSkins | fastCoinsToDollar}}"
                   matTooltipPosition="above"
                   [matTooltipDisabled]="!isGoFast"
              >{{balanceTopPanel?.outSkins / 100 || 0 | number | customCurrency}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
